import { UPDATE_SESSIONS, REFRESH_SESSION, HAVE_MORE, ADD_FALSE_LAST_MSG } from './../mutation-types';
import sdk from './../../global/sdk';
import config from './../../global/config';
import global_utils from './../../global/utils';
import util from './../../utils/util';
import falseNewsDic from './../../global/falseNewsDic';
import Vue from "vue";

const getShopKey = global_utils.getShopKey;

const isEmpty = global_utils.isEmpty;

const sumBigNumber = util.sumBigNumber;

const compareMsg = function (before, after) {
  if (!before?.msg) {
    return true;
  } else if (!after?.msg) {
    return false
  } else if (!before?.msg && !after?.msg) {
    return true;
  }
  if (!isEmpty(before.falseLastMsg.msg_id) && !isEmpty(after.falseLastMsg.msg_id)) {
    return before.falseLastMsg.send_time > after.falseLastMsg.send_time
  } else if (!isEmpty(before.falseLastMsg.msg_id) && isEmpty(after.falseLastMsg.msg_id)) {
    return before.falseLastMsg.send_time > after.msg.send_time
  } else if (isEmpty(before.falseLastMsg.msg_id) && !isEmpty(after.falseLastMsg.msg_id)) {
    return before.msg.send_time > after.falseLastMsg.send_time
  } else {
    return before.msg.msg_id > after.msg.msg_id
  }
}
let isAnonymousSession = global_utils.isAnonymousSession;


export default {
  state: {
    sessions: [],
    have_more: true,
    sessions_msgs_hash: {}
  },
  getters: {
    orderedSessions: (state) => {
      let me = sdk.get().me();
      let meKey = me.user_id + '@' + me.user_source;
      let sessions = (state.sessions || []).concat();
      let topSessions = [];
      let newSessions = sessions.filter((item) => {
        if (item && item.contact && item.contact.user_id && item.contact.user_source && falseNewsDic.getFalseLastMsg(item.contact.user_id + '@' + item.contact.user_source)) {
          let falseLastMsg = falseNewsDic.getFalseLastMsg(item.contact.user_id + '@' + item.contact.user_source);
          item.falseLastMsg = (meKey === falseLastMsg.belong_to && falseLastMsg.msg_id > item.msg.msg_id) ? falseLastMsg : {};
        } else {
          item.falseLastMsg = {};
        }
        if (item && item.is_top_group) {
          topSessions.push(item);
        }
        return !item.is_top_group && item?.msg;
      })
      newSessions.filter((session)=>{
        return !!session?.msg;
      }).sort((before, after) => {
        let before_ses_top = before.contact && before.contact.msg_set && before.contact.msg_set.ses_top === 1;
        let after_ses_top = after.contact && after.contact.msg_set && after.contact.msg_set.ses_top === 1;
        if (before_ses_top && after_ses_top) {
          return compareMsg(before, after) ? -1 : 1;
        } else if (before_ses_top || after_ses_top) {
          return before_ses_top ? -1 : 1;
        } else {
          return compareMsg(before, after) ? -1 : 1;
        }
      });
      return topSessions.concat(newSessions);
    }
  },
  mutations: {
    [HAVE_MORE](state, payload) {
      state.have_more = payload;
    },
    [UPDATE_SESSIONS](state, payload) {
      let me = sdk.get().me();
      state.sessions.splice(0, state.sessions.length);
      payload.forEach((item) => {
        let shopKey = getShopKey(item.msg, me);
        let contactKey = item.contact.user_id + '@' + item.contact.user_source;
        if (!isEmpty(shopKey)) {
          contactKey += '@@' + shopKey;
        }
        if (item.contact.user_id == config.get('notice_user_id')) {
          item.contact.user_name = '提醒服务';
          item.contact.avatar = 'http://static.58.com/git/teg-app-fe/im-images/xcx-images/remind_icon@2x.png'
        }
        state.sessions_msgs_hash[contactKey] = item.msg;
        state.sessions.push(item);
      });
    },
    [ADD_FALSE_LAST_MSG](state, payload) {
      let { tmpKey, lastMsg, last_msg_id } = payload;
      if (!isEmpty(state.sessions_msgs_hash[tmpKey])) {
        if (isEmpty(last_msg_id) && !isEmpty(state.sessions_msgs_hash[tmpKey])) {
          last_msg_id = state.sessions_msgs_hash[tmpKey].msg_id
        }
        if (!isEmpty(last_msg_id)) {
          falseNewsDic.setFalseLastMsg(tmpKey, Object.assign({}, lastMsg, {
            msg_id: sumBigNumber(last_msg_id, '1')
          }))
        }
      }
    },
    [REFRESH_SESSION](state, contactKey) {
      let sessions = (state.sessions || []).concat();
      for (let index = 0; index < sessions.length; index++) {
        let session = sessions[index];
        if (!isEmpty(session.contact) && (session.contact.user_id + '@' + session.contact.user_source === contactKey)) {
          sessions[index] = {
            ...session
          }
        }
      }
      Vue.set(state, 'sessions', sessions);
    }
  },
  actions: {
    getSessions: function ({ commit }) {
      sdk.get().getSessions({}, (sessions, have_more) => {
        if (!have_more) {
          commit('HAVE_MORE', have_more);
        }
      });
    },
    reloadSessions: function ({ commit }) {
      sdk.get().reloadSessions({}, (sessions, have_more) => {
        sdk.get().resetLoadedMsg();
        sdk.get().resetLoadedUser();
        if (!have_more) {
          commit('HAVE_MORE', have_more);
        }
      });
    },
    updateSessions({ commit }, sessions) {
      sessions.forEach(item => {
        var avatar = item.contact && item.contact.avatar;
        if (!avatar) {
          item.contact = item.contact ? item.contact : {};
          item.contact.avatar = isAnonymousSession(item.contact) ? config.get('default-anonymous-avatar') : config.get('default_avatar');
        }
      });
      commit('UPDATE_SESSIONS', sessions);
    },
    addFalseLastMsgs({ commit }, falseMsgsObj) {
      if (!isEmpty(falseMsgsObj)) {
        let { tmpKey, falseMsgs, last_msg_id } = falseMsgsObj;
        if (!isEmpty(tmpKey) && !isEmpty(falseMsgs) && falseMsgs.length) {
          let lastMsg = falseMsgs[falseMsgs.length - 1];
          lastMsg.tmpKey = tmpKey;
          commit('ADD_FALSE_LAST_MSG', {
            tmpKey,
            lastMsg,
            last_msg_id
          });
          commit('REFRESH_SESSION', tmpKey);
        }
      }
    },
    getContactList: function ({ commit }) {
      sdk.get().getSessions({ count: 20 }, (sessions, have_more) => {
        if (!have_more) {
          commit('HAVE_MORE', have_more);
        }
      });
    },
  }
};
